
<div class="col-6">
    <input type="text" class="form-control" value="Is" disabled />
</div>
<div class="col-6 d-flex align-items-center">
    <div class="row">
        <label>
            <input type="checkbox" class="me-2" [(ngModel)]="this.Value" (ngModelChange)="updateFilterSettings()" />
            {{ this.FilterInputs }}
        </label>
    </div>
</div>